export default __webpack_public_path__ + "static/media/logo.5ff6dd99.png";